module.exports = __webpack_public_path__ + "img/gauge-min.897f144a.svg";